import { render, staticRenderFns } from "./Sandoz-Schweiz.vue?vue&type=template&id=330ebb2d&scoped=true"
import script from "./Sandoz-Schweiz.vue?vue&type=script&lang=js"
export * from "./Sandoz-Schweiz.vue?vue&type=script&lang=js"
import style0 from "./Sandoz-Schweiz.vue?vue&type=style&index=0&id=330ebb2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330ebb2d",
  null
  
)

export default component.exports